import { OpenErrorNotification } from "@ctsu/react-ctsu-ui";
import { studyTypeLovContext } from "components/common/StudyTypeLovs";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { findIndex, move, propEq, uniq } from "ramda";
import { rootUrl, rosterUrl, sitesUrl } from "../constants";

import {
  FETCH_INSTITUTION_AFFILIATION_DETAILS,
  FETCH_INSTITUTION_AFFILIATION_SUMMARY,
  FETCH_INSTITUTION_PACKAGE_TREE_DETAILS,
  INSTITUTION_STATUS_LIST,
  IS_PACKAGE_CLAIMABLE,
  UI_PUT_INSTITUTION_AFFILIATION
} from "../types";

function parseStatusList(result) {
  return JSON.parse(
    JSON.stringify(result).replace(/"[^"]*"|\S+/g, (match) => {
      if (match[0] === '"') {
        return match.trim();
      } else {
        return match;
      }
    })
  ).shift();
}
function addIndex(responseData) {
  if (Array.isArray(responseData) && responseData.length > 0) {
    return responseData.map((item, index) => ({ ...item, id: index }));
  }
  return responseData;
}

function getStatus(result, col) {
  if (result.length) {
    let memberRoleStatusTo = [];
    const statusList = parseStatusList(result);
    if (statusList.memberRoleStatusTo) {
      memberRoleStatusTo = statusList.memberRoleStatusTo.split(",").map(d => ({ value: d, label: d }));
    }
    const b = statusList.memberRoleStatusFrom;
    return [{ value: b, label: b }, ...memberRoleStatusTo];
  }
  return [{ value: col.memberRoleStatus, label: col.memberRoleStatus }];
}

function getLovs(col, isEditing = false) {
  const data = studyTypeLovContext();
  const result = data.filter(
    d =>
      d.rosterOwner === col.infoSource &&
      d.studyType === col.memberStudyType &&
      d.memberRole === col.memberRole &&
      d.memberRoleStatusFrom === col.memberRoleStatus
  );
  const list = {
    isEditing,
    statusList: getStatus(result, col),
    studyTypeList: uniq(data.map(b => b.studyType)).map(d => ({ value: d, label: d })),
    memberRoleList: uniq(data.map(b => b.memberRole)).map(d => ({ value: d, label: d }))
  };
  return Promise.resolve(list);
}

// on PageLoad (/institution/roster)
//  FIRST : instiution affilations are loaded THEN based on the first record on the list affilation summary is loaded
// THEN Insitution List of Values are loaded
// THEN based on the institution values lists of unique values are compiled for  memberRoleList and memberRoleStudyTypeList
//  a set of statuslist is compiled basesed on current on the first record on the list affilation summary

export const fetchInstitutionAffiliationDetails = (ctepId, orgId, userGroup) => async dispatch => {
  let claimableCheck = "N";
  let claimableCheckPackage = "N";
  try {
    claimableCheck = await makeAjaxRequest.fetchWithAuth(
      `${rosterUrl}/owner/${userGroup}/organizations/${orgId}/claimablecheck`
    );
  } catch (error) {
    claimableCheck = "error";
    OpenErrorNotification({ message: error.message, autoHide: true });
  }
  try {
    claimableCheckPackage = await makeAjaxRequest.postWithAuth(
      `${rosterUrl}/owner/${userGroup}/package/${ctepId}/claim`,
      {}
    );
  } catch (error) {
    claimableCheckPackage = "error";
    OpenErrorNotification({ message: error.message, autoHide: true });
  }
  dispatch({
    type: FETCH_INSTITUTION_AFFILIATION_DETAILS,
    payload: makeAjaxRequest.postWithAuth(`${sitesUrl}/${ctepId}/affiliations`, {}).then(res => {
      const indexOfUserGroup = findIndex(propEq("infoSource", userGroup))(res.data);
      const modifiedData = move(indexOfUserGroup, 0, res.data);
      const data = addIndex(modifiedData);
      return {
        claimableCheckPackage,
        claimableCheck,
        ...res,
        data
      };
    })
  });
};

export const evalInstitutionStatusList = value => async dispatch => {
  dispatch({
    type: INSTITUTION_STATUS_LIST,
    payload: Promise.resolve(getLovs(value, true))
  });
};

export const startClaimPackage = (packageName, rosterOwner, callBack) => async dispatch => {
  const response = dispatch({
    type: FETCH_INSTITUTION_PACKAGE_TREE_DETAILS,
    payload: makeAjaxRequest.fetchWithAuth(`${sitesUrl}/${packageName}/tree?userGroup=CTSU`).then(data => {
      const res = JSON.parse(JSON.stringify(data).replace(/'/gi, ""));
      return res;
    })
  });
  response.then(() => callBack(true));
};

export const claimPackage = (packageName, rosterOwner, callBack) => async dispatch => {
  dispatch({
    type: "UI_CLAIM_INSTITUTION_PACKAGE",
    payload: makeAjaxRequest
      .fetchWithAuth(`${rosterUrl}/owner/${rosterOwner}/package/${packageName}/validate`)
      .then(data => callBack(data))
  });
};

// when the PUT call is sucessfull (data is saved in DB),
// 1. refresh the grid (to show the updated data) by dispatching FETCH_INSTITUTION_AFFILIATION_DETAILS
// 2. refresh the summary on RHS by dispatching FETCH_INSTITUTION_AFFILIATION_SUMMARY
// 3. get the list of values
// 4. check if the new package is claimable

export const putInstitutionAffiliationSummary = (siteCtepId, formData, callback) => async dispatch => {
  const response = dispatch({
    type: UI_PUT_INSTITUTION_AFFILIATION,
    payload: makeAjaxRequest.putWithAuth(`${sitesUrl}/${siteCtepId}/affiliations`, formData)
  });
  response
    .then(({ value }) =>
      dispatch({
        type: FETCH_INSTITUTION_AFFILIATION_DETAILS,
        payload: makeAjaxRequest.postWithAuth(`${sitesUrl}/${siteCtepId}/affiliations`, {})
      })
    )
    .then(({ value }) =>
      dispatch({
        type: FETCH_INSTITUTION_AFFILIATION_SUMMARY,
        payload: makeAjaxRequest.fetchWithAuth(`${rootUrl}/sites/affiliations/id/${value.data[0].id}/summary`) // COREAPI-890
      })
    )
    .then(({ value }) =>
      dispatch({
        type: INSTITUTION_STATUS_LIST,
        payload: Promise.resolve(getLovs(value))
      })
        .then(data => {})
        .then(() => {
          dispatch({
            type: IS_PACKAGE_CLAIMABLE,
            payload: makeAjaxRequest.postWithAuth(
              `${rosterUrl}/owner/${value.rootParentCtepId}/package/${value.infoSource}/claim`,
              {}
            )
          });
        })
    );
};
